import { BaSeTheme } from '@base/react';
import styled, { css } from 'styled-components';

const handleQuery = (style) => {
  return `
    ${BaSeTheme.breakpoints.mobileLarge.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobile.mediaQueryCss(style)};
    ${BaSeTheme.breakpoints.mobileSmall.mediaQueryCss(style)};

  `;
};

export const Container = styled.div`
  display: grid;
  grid-template-columns: 45% 45%;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;

  ${handleQuery(css`
    display: flex;
    flex-direction: column;
  `)}
`;

export const ContentGraph = styled.div`
  width: 100%;
`;

export const HeaderInfo = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 8px;
  background-color: #0000c9;
`;

export const AlignText = styled.div`
  display: grid;
  gap: 8px;
  margin-top: 8px;
`;
